<template>
  <div class="Form__group" :class="{ 'is--error' : error }">
    <label :for="id">{{ label }} <abbr v-if="required" title="Requis">*</abbr></label>
    <textarea class="Form__control" :class="{'has--rows': !!rows}"
           :id="id"
           :type="type"
           :name="name"
           :placeholder="placeholder"
           :required="!!required"
           :aria-required="!!required"
           :maxLength="maxLength"
           :value="modelValue"
            :rows="rows"
           @input="$emit('update:modelValue', $event.target.value)"
            :disabled="!!disabled"
    ></textarea>
    <span v-if="error" class="error">{{ error }}</span>
    <template v-else-if="errors">
      <span v-for="error in errors" class="error">{{ error }}</span>
    </template>  </div>
</template>

<script>
export default {
  props : [ 'name', 'label', 'id', 'type', 'placeholder', 'required', 'error', 'errors', 'modelValue', 'maxLength', 'disabled', 'rows'],
}
</script>
